import { NoteContent } from "../../../Components/NotesApp/NoteAppInterface";
export const WhiteHouseNoteContent: NoteContent[] = [
  {
    title: "412 Orchard avenue",
    date: "6 Dec 2022 8:24 PM",
    content: [
      {
        entry: "412 Orchard avenue",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Terence Simpson, a secret history of Taiwan",
    date: "1 Dec 2022 4:13 PM",
    content: [
      {
        entry: "Terence Simpson, a secret history of Taiwan",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Riad Baraka, Marrakech",
    date: "19 Nov 2022 10:59 PM",
    content: [
      {
        entry: "Riad Baraka, Marrakech",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Frank’s birthday on November 30",
    date: "8 Nov 2022 11:22 AM",
    content: [
      {
        entry: "Frank’s birthday on November 30",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Bougainvillea box of 24 chocolates",
    date: "21 Oct 2022 6:56 PM",
    content: [
      {
        entry: "Bougainvillea box of 24 chocolates",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "12 pack biggies diapers",
    date: "29 Sep 2022 1:13 PM",
    content: [
      {
        entry: "12 pack biggies diapers",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Megalith cinema opening September 19, downtown",
    date: "2 Sep 2022 5:45 PM",
    content: [
      {
        entry: "Megalith cinema opening September 19, downtown",
      },
    ],
    locked: false,
    unclickable: true,
  },
  {
    title: "Ask Angela to buy a card for Mom and Alvin",
    date: "6 Aug 2022 9:37 AM",
    content: [
      {
        entry: "Ask Angela to buy a card for Mom and Alvin",
      },
    ],
    locked: false,
    unclickable: true,
  },
];
